import { AnimatePresence, motion } from 'framer-motion';
import useCountdown from '../../hooks/useCountdown';

/**
 * Componente reutilizável de countdown visual
 * Usa o mesmo estilo do NextIn (pill branca + bolinha amarela)
 * @param {number} initialSeconds - Segundos iniciais do countdown
 * @param {string} label - Texto a exibir na pill
 * @param {boolean} isVisible - Se o countdown deve estar visível
 * @param {number} size - Tamanho do relógio (multiplicador)
 * @param {function} onComplete - Callback quando countdown chega a zero
 */
export default function CountdownClock({
  initialSeconds = 3,
  label = "Next in...",
  isVisible = true,
  size = 1.5,
  onComplete
}) {
  // Usa hook de countdown baseado em timestamp
  const seconds = useCountdown(initialSeconds, isVisible, onComplete);

  if (!isVisible) return null;

  // Valores relativos baseados no tamanho (mesmo do NextIn)
  const baseHeight = 40 * size;
  const fontSize = 16 * size;
  const pillPaddingY = 6 * size;
  const pillPaddingX = 18 * size;
  const gap = 8 * size;

  return (
    <div style={{ position: 'absolute', left: '50%', top: '20px', transform: 'translateX(-50%)', zIndex: 10 }}>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ y: -100 }}
            animate={{ y: 0 }}
            exit={{ y: -100 }}
            transition={{ duration: 0.4, delay: 0.2 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: `${gap}px`,
                width: "fit-content",
              }}
            >
              {/* pill branca */}
              <div
                style={{
                  backgroundColor: "#FAF6EC",
                  color: "#333",
                  borderRadius: "9999px",
                  padding: `${pillPaddingY}px ${pillPaddingX * 2}px ${pillPaddingY}px ${pillPaddingX}px`,
                  fontSize: `${14 * size}px`,
                  fontWeight: 500,
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  lineHeight: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {label}
              </div>

              {/* bolinha amarela encaixada */}
              <div
                style={{
                  marginLeft: `${-baseHeight * 0.9}px`,
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    backgroundColor: "#FDBE2D",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: `${fontSize}px`,
                    width: `${baseHeight}px`,
                    height: `${baseHeight}px`,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                  }}
                >
                  {seconds}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

